/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Combo_Recipe_Col_TypeInputs */

const vi_combo_recipe_col_type = /** @type {(inputs: Combo_Recipe_Col_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loại`)
};

/**

* @param {Combo_Recipe_Col_TypeInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const combo_recipe_col_type = /** @type {((inputs?: Combo_Recipe_Col_TypeInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Combo_Recipe_Col_TypeInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_combo_recipe_col_type(inputs)
});